import App from './app'

const app = new App()
window.retroApp = app

export default app